import axios from "axios";
import SideBar from "./sidebar/ManagerSideBar";
import DashBoardNavbar from "./navbar/DashBoardNavbar";
// export default ProjectDetails;
import * as React from 'react';
import { styled } from '@mui/system';
import TablePagination, {
  tablePaginationClasses as classes,
} from '@mui/base/TablePagination';
import { useNavigate } from 'react-router';
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";


function ChangeLogs() {
  const [user, setuser] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  let navigate = useNavigate();
  const userType = sessionStorage.getItem('role') == 'Admin'

  const getData = () => {
    let data = axios.get('/api/logs', {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        setRows(response.data.reverse())
      })
      .catch(error => {
        // Handle error
        console.error(error);
      });

  }
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    showSuccessToast(`Rows Per Page changed to ${parseInt(event.target.value, 10)}`)
  };
  React.useEffect(() => {
    getData()

  }, [])
  const blue = {
    200: '#A5D8FF',
    400: '#3399FF',
  };

  const grey = {
    50: '#F3F6F9',
    100: '#E7EBF0',
    200: '#E0E3E7',
    300: '#CDD2D7',
    400: '#B2BAC2',
    500: '#A0AAB4',
    600: '#6F7E8C',
    700: '#3E5060',
    800: '#2D3843',
    900: '#1A2027',
  };

  const Root = styled('div')(
    ({ theme }) => `
    table {
      font-family: IBM Plex Sans, sans-serif;
      font-size: 0.875rem;
      border-collapse: collapse;
      width: 100%;
    }
  
    td,
    th {
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      text-align: left;
      padding: 6px;
    }
  
    th {
      background-color: ${theme.palette.mode === 'dark' ? grey[900] : grey[100]};
    }
    `,
  );

  const CustomTablePagination = styled(TablePagination)(
    ({ theme }) => `
    & .${classes.spacer} {
      display: none;
    }
  
    & .${classes.toolbar}  {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
  
      @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
      }
    }
  
    & .${classes.selectLabel} {
      margin: 0;
    }
  
    & .${classes.select}{
      padding: 2px;
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      border-radius: 50px;
      background-color: transparent;
  
      &:hover {
        background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
      }
  
      &:focus {
        outline: 1px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
      }
    }
  
    & .${classes.displayedRows} {
      margin: 0;
  
      @media (min-width: 768px) {
        margin-left: auto;
      }
    }
  
    & .${classes.actions} {
      padding: 2px;
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      border-radius: 50px;
      text-align: center;
    }
  
    & .${classes.actions} > button {
      margin: 0 8px;
      border: transparent;
      border-radius: 2px;
      background-color: transparent;
  
      &:hover {
        background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
      }
  
      &:focus {
        outline: 1px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
      }
    }
    `,
  );

  const logOut = () => {
    sessionStorage.clear();
    navigate('/login')


  }



  return (
    <body className={`overflow-hidden grad ${windowWidth <= 1200 ? "" : "g-sidenav-show"}`}>
      {/* side navbar */}
      {windowWidth >= 1200 && <SideBar />}
      <main className="main-content position-relative h-100 border-radius-lg">

        <DashBoardNavbar user={user} logOut={logOut} />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card my-4">
                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                  <div className="bg-gradient-info shadow-info border-radius-lg pt-4 pb-3">
                    <h6 className="text-white text-capitalize ps-3">
                      Logs
                    </h6>
                  </div>
                </div>
                <div className="card-body px-4 pb-2">
                  <div className="table-responsive p-0 d-flex justify-content-center align-items-center">
                    <Root className="d-flex align-items-center justify-content-center" sx={{ width: 1500, maxWidth: '100%' }}>
                      <table aria-label="custom pagination table" style={{ width: '90' }}>
                        <thead>
                          <tr>
                            <th style={{ width: '5%' }}>Sr No.</th>

                            <th style={{ width: '20%' }}>TimeStamp</th>

                            <th style={{ width: '25%' }}>Message</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                          ).map((row, index) => (
                            <tr key={row._id}>
                              <td>{(index + 1) + (rowsPerPage * (page ))}</td>

                              <td align="right">
                                {row.creation ? new Date(row.creation).toLocaleString() : ""}
                              </td>
                              <td align="right">
                                {row.Message ? row.Message : "No Message"}
                              </td>

                            </tr>
                          ))}


                        </tbody>
                        <tfoot>
                          <tr>
                            <CustomTablePagination
                              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                              colSpan={3}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              slotProps={{
                                select: {
                                  'aria-label': 'rows per page',
                                },
                                actions: {
                                  showFirstButton: true,
                                  showLastButton: true,
                                },
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                          </tr>
                        </tfoot>
                      </table>
                    </Root>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </body>
  );
}

export default ChangeLogs;






